module.exports = __webpack_public_path__ + "20250721160708/img/guding.9928b897.png";